export default {
  "brand": "text-text-brand",
  "bronze": "text-text-bronze",
  "coral": "text-text-coral",
  "disabled": "text-text-disabled",
  "error": "text-text-error",
  "error-primary": "text-text-error-primary",
  "error-secondary": "text-text-error-secondary",
  "gold": "text-text-gold",
  "infos": "text-text-infos",
  "infos-primary": "text-text-infos-primary",
  "infos-secondary": "text-text-infos-secondary",
  "primary": "text-text-primary",
  "primary-fixed": "text-text-primary-fixed",
  "primary-inverse": "text-text-primary-inverse",
  "primary-inverse-fixed": "text-text-primary-inverse-fixed",
  "promotion": "text-text-promotion",
  "purple": "text-text-purple",
  "rose": "text-text-rose",
  "secondary": "text-text-secondary",
  "secondary-inverse": "text-text-secondary-inverse",
  "secondary-inverse-fixed": "text-text-secondary-inverse-fixed",
  "sephora-collection": "text-text-sephora-collection",
  "silver": "text-text-silver",
  "success": "text-text-success",
  "success-primary": "text-text-success-primary",
  "success-secondary": "text-text-success-secondary",
  "tertiary": "text-text-tertiary",
  "tertiary-inverse": "text-text-tertiary-inverse",
  "tertiary-inverse-fixed": "text-text-tertiary-inverse-fixed",
  "warning": "text-text-warning",
  "warning-primary": "text-text-warning-primary",
  "warning-secondary": "text-text-warning-secondary",
  "yellow": "text-text-yellow"
}